export default __webpack_public_path__ + "static/runa_1_1_en-6cfd03f4e4ddd0334ed94374d3b2f4bf.png";